const formattedFutureMonthData = (data) =>
  data.map((d, index) => {
    return {
      id: index + 1,
      AOP: d.AOP,
      M: d.M,
      M1: d.M1,
      M2: d.M2,
      OutletType: d.OutletType,
      Pricelist: d.Pricelist,
      ProductCode: d.ProductCode,
      Product_Name: d.Product_Name,
      Warehouse: d.Warehouse,
      ...d.daily_sales,
    };
  });

export { formattedFutureMonthData };
